import React from 'react';
import { Link } from 'react-router-dom';
import NoPagination from '../../components/pagination/noPagination.jsx';
import LabelCategory from '../../components/label/label-category.jsx';
import LabelNumber from '../../components/label/label-number.jsx';
import LinkDownload from '../../components/link/link-download.jsx';
import { Colors, Productos } from '../../constants';
import env from '../../environment.js';
import { getIdCatCreditoPrecosecha } from '../../components/content/coop-config.jsx';
import insertIf from '../../utils/insertIf.js';
import getRiesgoEudrLabel from '../../nuup/utils/getRiesgoEudrLabel.js';
import LabelEudrProducer from '../../components/label/label-eudr-prod.jsx';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';
import transformWord from '../../utils/transformWord.js';

const EntregasXProductorTable = ({
  blocking,
  selected = 'id',
  data,
  fnBackgroundColor,
  fnColor,
  coopConfig,
  selectedData,
  setSelectedData,
  // Permite definir la lógica de checked desde el consumidor
  isChecked,
  multiSelect = false,
  isAsignarEntregas=false
}) => {
  
  // Solo para multiSelect
  const allSelected = Array.isArray(selectedData) && data?.length > 0 && selectedData.length === data.length;
  const indeterminate = Array.isArray(selectedData) && data?.length > 0 && selectedData.length > 0 && selectedData.length < data.length;
  const isCafeOrPimienta = () => {
    return [Productos.CAFE, Productos.PIMIENTA].includes(+coopConfig?.config?.cooperativa?.producto?.id);
  };

  const columns = React.useMemo(
    () => [
      {
        Header: 'ENTREGA',
        columns: [
          {
            Header: multiSelect ? (
                <input
                  type="checkbox"
                  name="entregasAll"
                  style={{ 
                    width: 20, 
                    height: 20, 
                    accentColor: Colors.primary_600,
                    display: data.length > 0 ? 'block' : 'none',
                  }}
                  onChange={e => {
                    setSelectedData(e.target.checked ? [...data] : []);
                  }}
                  checked={allSelected}
                  ref={el => el && (el.indeterminate = indeterminate)}
                />
            ) : '',
            id: 'acopio_uuid',
            accessor: 'x',
            sortable: false,
            width: 25,
            Cell: ({ row }) => {
              return (
                <div className="form-check">
                  <input
                    className="form-check-input"
                    name="entregas"
                    type="checkbox"
                    style={{ width: 20, height: 20, accentColor: Colors.primary_600 }}
                    value={row.original.acopio_uuid}
                    onChange={e => {
                      if (multiSelect) {
                        setSelectedData(prev => {
                          const currentArray = Array.isArray(prev) ? prev : [];
                          if (e.target.checked) {
                            return [...currentArray, row.original];
                          } else {
                            return currentArray.filter(
                              item => item.acopio_uuid !== row.original.acopio_uuid
                            );
                          }
                        });
                      } else {
                        setSelectedData(() => {
                          return e.target.checked ? row.original : '';
                        });
                      }
                    }}
                    checked={
                      typeof isChecked === 'function'
                        ? !!isChecked(row.original, selectedData)
                        : multiSelect
                        ? Array.isArray(selectedData) && selectedData.some(item => item.acopio_uuid === row.original.acopio_uuid)
                        : (selectedData?.acopio_uuid === row.original.acopio_uuid) === true
                    }
                  />
                </div>
              );
            },
          },
          {
            Header: 'FECHA ENTREGA',
            accessor: 'fecha_acopio',
            sortable: true,
            minWidth: 80,
            Cell: ({ value }) => {
              return <p className="text-left">{value != null ? value.substr(0, 10) : ''}</p>;
            },
          },
          {
            Header: 'FOLIO ENTREGA',
            accessor: 'folio_acopio',
            sortable: true,
            minWidth: 50,
          },
          ...insertIf(isAsignarEntregas, {
            Header: 'FOLIO/LOTE',
            accessor: 'nombre_lote',
            sortable: true,
            minWidth: 50,
          }),
          ...insertIf(isAsignarEntregas && !coopConfig.hasAcopioUnitsExtra(), {
            Header: `PESO NETO (${coopConfig.acopioUnits()?.abreviacion})`,
            accessor: 'peso_neto',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2}></LabelNumber>;
            },
          }),
          ...insertIf(isAsignarEntregas && coopConfig.hasAcopioUnitsExtra(), {
            Header: `PESO NETO (${coopConfig.acopioUnitsExtra()?.abreviacion})`,
            accessor: 'peso_neto_extra',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2}></LabelNumber>;
            },
          }),
          ...insertIf(isAsignarEntregas && !coopConfig.hasAcopioUnitsExtra(), {
            Header: `PESO DISPONIBLE (${coopConfig.acopioUnits()?.abreviacion})`,
            accessor: 'peso_pendiente',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2}></LabelNumber>;
            },
          }),
          ...insertIf(isAsignarEntregas && coopConfig.hasAcopioUnitsExtra(), {
            Header: `PESO DISPONIBLE (${coopConfig.acopioUnitsExtra()?.abreviacion})`,
            accessor: 'peso_pendiente_extra',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2}></LabelNumber>;
            },
          }),
          ...insertIf(isAsignarEntregas, {
            Header: 'PESO ASIGNADO %',
            minWidth: 50,
            Cell: ({ row }) => {
              if (row.original.peso_asignado <= 0) {
                return <p className="text-right" style={{ margin: 0 }}>{'-'}</p>
              }
              
              const percentage = (row.original.peso_asignado / row.original.peso_neto) * 100;
              const dataGrafica = [
                { name: 'Sobrante', value: Math.max(0, 100 - percentage) },
                { name: 'Asignado', value: percentage },
              ];

              return (
                <div className="d-flex align-items-center justify-content-center" style={{ gap: '6px', margin: 0, padding: 0 }}>
                  <PieChart width={26} height={26} margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
                    <Pie
                      data={dataGrafica}
                      cx={13}
                      cy={13}
                      innerRadius={0}
                      outerRadius={11}
                      paddingAngle={0}
                      dataKey="value"
                      startAngle={90}
                      endAngle={450}
                      stroke="none"
                      isAnimationActive={false}
                    >
                      <Cell key="cell-0" fill={Colors.primary_500} />
                      <Cell key="cell-1" fill={Colors.neutral_100} />
                    </Pie>
                  </PieChart>
                </div>
              );
            },
          }),
          {
            Header: 'RECIBOS',
            accessor: 'recibo_pdf',
            sortable: true,
            Cell: ({ row }) => {
              return (
                <LinkDownload url={`recibos/entregas/descargar/${row.original.acopio_uuid}`} label="Descargar" icon={env.images.icon.pdf} />
              );
            },
          },
        ],
      },
      {
        Header: 'INFORMACIÓN DE PRODUCTOR',
        columns: [
          {
            Header: 'CLAVE',
            accessor: 'productor_clave_tx',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return (
                <p className="text-right" style={{ margin: 0 }}>
                  {value}
                </p>
              );
            },
          },
          {
            Header: 'CÓDIGO',
            accessor: 'productor_codigo_tx',
            sortable: true,
            minWidth: 50,
            show: !!+coopConfig.config?.usa_codigo_tx,
          },
          {
            Header: 'NOMBRE PRODUCTOR',
            accessor: 'productor_nombre',
            sortable: true,
            minWidth: 50,
            Cell: ({ value, row }) => {
              if (row.original.productor_uuid != null) {
                return (
                  <Link
                    to={{ pathname: `/admin/cuentas/perfil/${row.original.productor_uuid}` }}
                    className="m-r-2"
                    style={{ color: '#789D16' }}>
                    <span>{value}</span>
                  </Link>
                );
              } else {
                return value;
              }
            },
          },
          {
            Header: 'LOCALIDAD',
            accessor: 'localidad',
            sortable: true,
            minWidth: 50,
          },
          {
            Header: 'REGIÓN',
            accessor: 'region',
            sortable: true,
            minWidth: 50,
          },
          {
            Header: 'CENTRO DE ACOPIO',
            accessor: 'centro_acopio',
            sortable: true,
            minWidth: 50,
          },
          {
            Header: 'CATEGORÍA ORGÁNICA',
            accessor: 'cuenta_categoria',
            sortable: true,
            minWidth: 90,
            Cell: ({ value, row }) => {
              if (value != null) {
                return <LabelCategory label={value} color={row.original.cuenta_categoria_color}></LabelCategory>;
              } else {
                return value;
              }
            },
          },
          {
            Header: 'RIESGO EUDR',
            accessor: 'riesgo_eudr',
            sortable: true,
            minWidth: 80,
            show: !!+coopConfig.config?.usa_eudr,
            Cell: ({ value }) => <LabelEudrProducer riesgo={getRiesgoEudrLabel(value)} />,
          },
        ],
      },
      {
        Header: 'TIPO DE ENTREGA',
        columns: [
          {
            Header: 'TIPO DE ' + transformWord(coopConfig?.config?.cooperativa?.producto?.nombre, ['uppercase']),
            accessor: 'tipo_cafe',
            sortable: true,
            minWidth: 50,
            show: isCafeOrPimienta(),
          },
          {
            Header: 'PROCESO',
            accessor: 'proceso',
            sortable: true,
            minWidth: 50,
            show: isCafeOrPimienta(),
          },
          {
            Header: 'CATEGORÍA',
            accessor: 'tipos_entregas',
            sortable: true,
            minWidth: 50,
            show: coopConfig.mostrarTipo(),
          },
          {
            Header: 'COSTALERA',
            accessor: 'nombre_cat_costaleras_estatus',
            sortable: true,
            minWidth: 50,
            show: coopConfig.mostrarCostalera(),
            Cell: ({ value }) => {
              if (value != null) {
                return (
                  <p className="text-left" style={{ margin: 0 }}>
                    {value}
                  </p>
                );
              } else {
                return (
                  <p className="text-left" style={{ margin: 0 }}>
                    {'-'}
                  </p>
                );
              }
            },
          },
          ...insertIf(!isAsignarEntregas, {
            Header: 'LOTE',
            accessor: 'nombre_lote',
            sortable: true,
            minWidth: 50,
            show: coopConfig.mostrarLote(),
          }),
        ],
      },
      {
        Header: 'INFORMACIÓN DE ENTREGA',
        columns: [
        ...insertIf(+coopConfig.config?.cooperativa?.producto?.id === env.productos.MIEL, {
            Header: 'TAMBORES',
            accessor: 'tambor',
            sortable: true,
            minWidth: 50,
          }),
          {
            Header: 'Nº RECIPIENTES',
            accessor: 'no_bultos',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value}></LabelNumber>;
            },
          },
          {
            Header: `PESO BRUTO (${coopConfig.acopioUnits()?.abreviacion})`,
            accessor: 'peso_bruto',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2}></LabelNumber>;
            },
          },
          {
            Header: `PESO TARA (${coopConfig.acopioUnits()?.abreviacion})`,
            accessor: 'peso_tara',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2}></LabelNumber>;
            },
          },
          {
            Header: `PESO DESCUENTO${coopConfig.mostrarDescuentoHumedad() ? ' CALIDAD' : ''} (${coopConfig.acopioUnits()?.abreviacion})`,
            accessor: 'peso_descuento',
            sortable: true,
            minWidth: 50,
            show: coopConfig.mostrarDescuento() && !coopConfig.mostrarDescuentosPorcentaje(),
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2}></LabelNumber>;
            },
          },
          {
            Header: `DESCUENTO${coopConfig.mostrarDescuentoHumedad() ? ' CALIDAD' : ''} (%)`,
            accessor: 'peso_descuento_perc',
            sortable: true,
            minWidth: 50,
            show: coopConfig.mostrarDescuento() && coopConfig.mostrarDescuentosPorcentaje(),
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2} suffix={'%'} />;
            },
          },
          {
            Header: `PESO DESCUENTO HUMEDAD (${coopConfig.acopioUnits()?.abreviacion})`,
            accessor: 'peso_descuento_humedad',
            sortable: true,
            minWidth: 50,
            show: coopConfig.mostrarDescuentoHumedad() && !coopConfig.mostrarDescuentosPorcentaje(),
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2}></LabelNumber>;
            },
          },
          {
            Header: `DESCUENTO HUMEDAD (%)`,
            accessor: 'peso_descuento_humedad_perc',
            sortable: true,
            minWidth: 50,
            show: coopConfig.mostrarDescuentoHumedad() && coopConfig.mostrarDescuentosPorcentaje(),
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2} suffix={'%'} />;
            },
          },
          ...insertIf(!isAsignarEntregas, {
            Header: `PESO NETO (${coopConfig.acopioUnits()?.abreviacion})`,
            accessor: 'peso_neto',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2}></LabelNumber>;
            },
          }),
          ...insertIf(!isAsignarEntregas, {
            Header: `PESO NETO (${coopConfig.acopioUnitsExtra()?.abreviacion})`,
            accessor: 'peso_neto_extra',
            sortable: true,
            minWidth: 50,
            show: coopConfig.hasAcopioUnitsExtra(),
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2} />;
            },
          }),
        ],
      },
      {
        Header: 'RESULTADOS DE MUESTREO',
        columns: [
          {
            Header: 'MADURACIÓN',
            accessor: 'tipo_maduracion',
            sortable: true,
            minWidth: 50,
            show: !!+coopConfig?.config?.config_muestreo?.mostrar_tipo_maduracion,
          },
          {
            Header: 'RENDIMIENTO',
            accessor: 'rendimiento',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2} suffix={'%'}></LabelNumber>;
            },
            show: !!+coopConfig?.config?.config_muestreo?.mostrar_rendimiento,
          },
          {
            Header: 'HUMEDAD',
            accessor: 'humedad',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2} suffix={'%'}></LabelNumber>;
            },
            show: !!+coopConfig?.config?.config_muestreo?.mostrar_humedad,
          },
          {
            Header: 'DEFECTO',
            accessor: 'mancha',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2} suffix={'%'}></LabelNumber>;
            },
            show: !!+coopConfig?.config?.config_muestreo?.mostrar_mancha,
          },
          {
            Header: 'COLOR',
            accessor: 'color',
            sortable: true,
            minWidth: 50,
            show: !!+coopConfig?.config?.config_muestreo?.mostrar_color,
          },
          {
            Header: 'COLOR',
            accessor: 'color_de_cafe',
            sortable: true,
            minWidth: 50,
            show: !!+coopConfig?.config?.config_muestreo?.mostrar_color_de_cafe,
          },
          {
            Header: 'AROMA',
            accessor: 'aroma',
            sortable: true,
            minWidth: 50,
            show: !!+coopConfig?.config?.config_muestreo?.mostrar_aroma,
          },
          {
            Header: 'OBSERVACIONES',
            accessor: 'muestreo_observaciones',
            sortable: true,
            minWidth: 50,
            show: !!+coopConfig?.config?.config_muestreo?.mostrar_observaciones,
          },
          {
            Header: 'OBSERVACIONES',
            accessor: 'observaciones',
            sortable: true,
            minWidth: 50,
          },
        ],
      },
      {
        Header: 'INFORMACIÓN DE PAGO',
        columns: [
          {
            Header: `PRECIO A PRODUCTOR (${coopConfig.currency()?.symbol}/${coopConfig.acopioUnits()?.abreviacion})`,
            accessor: 'precio_por_kg',
            sortable: true,
            minWidth: 50,
            show: !coopConfig.hasAcopioUnitsExtra(),
            Cell: ({ value }) => {
              return <LabelNumber value={value} currencyLabel={coopConfig.currency()?.symbol} digits={2}></LabelNumber>;
            },
          },
          {
            Header: `PRECIO A PRODUCTOR (${coopConfig.currency()?.symbol}/${coopConfig.acopioUnitsExtra()?.abreviacion})`,
            accessor: 'precio_por_kg_extra',
            sortable: true,
            minWidth: 50,
            show: coopConfig.hasAcopioUnitsExtra(),
            Cell: ({ value }) => {
              return <LabelNumber value={value} currencyLabel={coopConfig.currency()?.symbol} digits={2} />;
            },
          },
          {
            Header: `IMPORTE TOTAL (${coopConfig.currency()?.symbol})`,
            accessor: 'importe_total',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} currencyLabel={coopConfig.currency()?.symbol} digits={2}></LabelNumber>;
            },
          },
          {
            Header: 'DESCUENTOS DEUDAS',
            accessor: 'total_anticipos_recuperados',
            sortable: true,
            minWidth: 50,
            show: getIdCatCreditoPrecosecha() > 1,
            Cell: ({ value }) => {
              return <LabelNumber value={value} currencyLabel={coopConfig.currency()?.symbol} digits={2}></LabelNumber>;
            },
          },
          {
            Header: `PAGADO A PRODUCTOR (${coopConfig.currency()?.symbol})`,
            accessor: 'pagado_a_productor',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} currencyLabel={coopConfig.currency()?.symbol} digits={2}></LabelNumber>;
            },
          },
          {
            Header: `SALDO DE LA ENTREGA (${coopConfig.currency()?.symbol})`,
            accessor: 'total_saldo',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} currencyLabel={coopConfig.currency()?.symbol} digits={2}></LabelNumber>;
            },
          },
          {
            Header: 'MÉTODO DE PAGO',
            accessor: 'metodo_pago',
            sortable: true,
            minWidth: 50,
          },
        ],
      },
            ...insertIf(!!+coopConfig.config?.usa_calidad, {
        Header: 'CALIDAD',
        columns: [
          { Header: 'ID MUESTRA', accessor: 'id_muestra', sortable: true, minWidth: 50 },
          { Header: 'TIPO DE MUESTRA', accessor: 'nombre_tipo_muestra', sortable: true, minWidth: 80 },
          { Header: 'RENDIMIENTO BRUTO (%)', accessor: 'rendimiento_bruto', sortable: true, minWidth: 60, Cell: ({ value }) => <LabelNumber value={value} digits={2} suffix={'%'} /> },
          { Header: 'RENDIMIENTO EXPORTABLE (%)', accessor: 'rendimiento_exportable_por', sortable: true, minWidth: 60, Cell: ({ value }) => <LabelNumber value={value} digits={2} suffix={'%'} /> },
          { Header: 'RENDIMIENTO REAL (%)', accessor: 'rendimiento_real', sortable: true, minWidth: 60, Cell: ({ value }) => <LabelNumber value={value} digits={2} suffix={'%'} /> },
          { Header: 'PUNTAJE EN TAZA', accessor: 'puntaje_manual', sortable: true, minWidth: 60, Cell: ({ value }) => <LabelNumber value={value} digits={2} /> },
        ],
      }),
    ],
    [coopConfig, selectedData, data, multiSelect, isChecked, setSelectedData, allSelected, indeterminate]
  );

  return (
    <NoPagination
      blocking={blocking}
      selected={selected}
      columns={columns}
      data={data}
      fnBackgroundColor={fnBackgroundColor}
      fnColor={fnColor}
    />
  );
};

export default EntregasXProductorTable;
